export default "__VITE_ASSET__rykRfF7O__"